import React, { useState, useEffect ,useLayoutEffect} from 'react';
import useMedia from 'use-media';
import { useRtoaster } from '../../../hooks/useRtoaster';

import image_base from '../../../resources/image/HakoneGardenTerrace.jpg';
import { Link ,useHistory} from "react-router-dom";
import image_complete from '../../../resources/icons/complete.svg';
import image_button from '../../../resources/icons/ico_reserve.svg';
import { connect , useStore} from 'react-redux';
import common from '../../../resources/js/common/common';
import { apiKeyCheck } from '../../../const';
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import {Button} from '../../atoms/button';
import './../../../resources_membership_hotel/css/hotel/membership_cancel_comp.css'

const CancelCompleteContainer = (props) => {
    const {  } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const store = useStore();
    const history = useHistory();

    // rtoasterタグ生成
    const membershipCancelReserveComf = store.getState().membershipCancelReserveComf;
    const customParam = {
        "riyosyodat": membershipCancelReserveComf.checkInDate,
        "sisetucd": membershipCancelReserveComf.shisetsuCd,
        "yoyakuno": membershipCancelReserveComf.yoyakuNo,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        // let state = store.getState().login;
        // let apiKey = null;
        // if(Object.keys(state).length !== 0){
        //     apiKey = state.apiKey;
        // }
        // if(apiKey === null){
        //     store.dispatch({ type: "CLEAR_STATE"});
        //     history.push("/reserve/login");
        // }
        // if(apiKey){
        // common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        // }
    })
    const afterApiKeyCheck = (res) => {
        // if(!res.data){
        //     console.log("バックからの戻り値false");
        //     store.dispatch({ type: "CLEAR_STATE"});
        //     history.push("/reserve/login");
        // }
    }

    // ホテル予約TOPへ戻るボタン押下処理
    const onClickHotelTopButton = () => {
        const isCrawl = store.getState().login.loginType === 'CRAWL';
        if (isCrawl) {
            history.push("/reserve/hotel/crawlSearch");
        } else {
            history.push("/reserve/hotel/search");
        }
    };

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        // common.versionCheck();

    }, []);

    return (
        <div style={isWideTablet ? styles.topCancel : styles.top}>
            <div className={isWideTablet ? "membership_base2" : "membership_base"}>
                <div style={styles.complete}></div>
                <p className="membership_cancel_title">予約のキャンセルを承りました</p>
                <p className={isWideTablet ? "membership_cancel_text2" : "membership_cancel_text"}>ご利用いただき誠にありがとうございます。<br />予約キャンセル完了メールをお送りいたしましたので、<br/>内容をご確認ください。</p>
                <div className='membership_btn_area'>
                <Button buttonText="ホテル予約TOPへ戻る" className="membership_top_btn" onClick={onClickHotelTopButton}/>
                </div>
            </div>
            <div className={isWideTablet ? "membership_cancel_footer2" : "membership_cancel_footer"} >
                <MembershipFooterContainer />
            </div>
        </div >
    )
}

const styles = {
    topMobile: {
        width: "100%",
        paddingTop: "25px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (12.3rem + 75px))",
    },
    top: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "#ebebeb",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    topCancel: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "#ebebeb",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (7.1rem + 100px))",
    },
    complete: {
        width: "50px",
        height: "50px",
        backgroundImage: `url(${image_complete})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        margin: "0px auto 10px",
    },

    box: {
        display: "inline-block",
        textAlign: "center",
        margin: "0px auto",
        width: "100%",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "25px",
    },
    deletebr: {
        display: "none",
    },
    deletebr2: {
        display: "block",
    },
    btn: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "60%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btn2: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "100%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btnImage: {
        width: "30px",
        height: "30px",
        backgroundImage: `url(${image_button})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        marginTop: "5px",
    },
    useBtn: {
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        display: "inline-block",
        border: "none"
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        marginLeft: "10%",
    },
    breadCrumbArrow: {
        marginRight: "16px",
        marginTop: "0px",
    },
    label: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "0.9rem",
        letterSpacing: "0.2rem"
    },
    label2: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: 12.6,
        letterSpacing: "0.2rem"
    },
    image: {
        width: 200,
        width: "40%",
        margin: "0 auto",
    },
    form: {
        width: "60%",
        margin: "0px auto 50px",
    },
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "45px auto 0px",
    },
}

export default CancelCompleteContainer;
